import { ReactNode } from "react";
import { Check } from "lucide-react";
import { Show } from "shared/components";
import { cx } from "shared/utils/classnames";

export const CreditScoreTimeLineItem = ({
  children,
  isLast,
  isFirst,
  wrapperClassName,
  childrenClassName,
  hideCheck
}: {
  children: ReactNode;
  isLast?: boolean;
  isFirst?: boolean;
  wrapperClassName?: string;
  childrenClassName?: string;
  hideCheck?: boolean;
}) => {
  return (
    <li className={cx("flex", wrapperClassName)}>
      <div className="flex flex-col items-center self-stretch">
        <div
          className={cx(
            "w-[3px] flex-1",
            isFirst ? "bg-transparent" : "bg-primary-500"
          )}
        />
        <div
          className={cx(
            "h-4 w-4 rounded-full bg-white border-[3px] border-primary-500 shrink-0",
            "flex items-center justify-center"
          )}
        >
          <Show if={!hideCheck}>
            <Check className="h-2.5 w-2.5 text-primary-500" strokeWidth={3} />
          </Show>
        </div>
        <div
          className={cx(
            "w-[3px] flex-1",
            isLast ? "bg-transparent" : "bg-primary-500"
          )}
        />
      </div>
      <div className={childrenClassName}>{children}</div>
    </li>
  );
};
